import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookOpen, faDownload, faFileDownload, faFilePdf, faPrint, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons'

import PDFPreviewModal from "./PDFPreviewModal";
import VenteDocument from "./VenteDocument";
import PartDocument from "./PartDocument";
import RecuDocument from "./RecuDocument";
import ContratDocument from "./ContratDocument";
import ClientDocument from "./ClientDocument";
import ListeEncaissementsDocument from "./ListeEncaissementsDocument";
import BordereauDocument from "./BordereauDocument";
import CommissionDocument from "./CommissionDocument";
import DechargeDocument from "./DechargeDocument";
import DTDocument from "./DTDocument";

import { uploadToFTP } from "../../flux/actions/venteActions";

import { IPdflink } from "../../types/interfaces";
import ReactPDF, { pdf } from '@react-pdf/renderer'
import { saveAs } from 'file-saver';
import printJS from 'print-js-updated'
import moment from "moment";
import { useAlert } from "react-alert";

import QRCode from 'qrcode';
import { createCanvas, loadImage } from 'canvas';

const PDFLink: React.FC<IPdflink> = ({documentType, fileName, title, data, fileObject, buttonText, download = true, print = false, spinner = false, style = {}, customClassNames, customButtonIcon, showPreviewWatermark = false, allowPrintPreview = false, htmlTitle = "", iconSize = undefined, buttonContent = undefined, htmlKey = undefined, largeModal = false, fontSizeFactor = 9, delaiMois = 24, func, actionAfterPrint}: IPdflink) => {
  const alert = useAlert();
  const [ready, setReady] = useState(false);
  const [disabled, setDisablePdf] = useState(false);
  const [modal, setModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');

  const handleToggle = () => setModal(!modal);

  useEffect(() => {
    setReady(false);
    setReady(true);
    return () => setReady(false);
  }, []);

  useEffect(() => {
    if(previewUrl !== '')
      setModal(true)
  }, [previewUrl]);
  
  if(buttonText === null || buttonText === undefined){
    if(print)
      buttonText = "Imprimer"
    else if(!download)
      buttonText = "Aperçu"
    else {
      if(documentType == "vente")
        buttonText = "Télécharger la fiche Vente"
      else if(documentType == "part")
        buttonText = "Télécharger la fiche Part"
      else if(documentType == "recu")
        buttonText = "Télécharger le Reçu"
      else if(documentType == "contrat")
        buttonText = "Télécharger le Contrat"
      else if(documentType == "client")
        buttonText = "Télécharger la fiche Client"
      else if(documentType == "encaissements")
        buttonText = "Télécharger les encaissements"
      else if(documentType == "bordereau")
        buttonText = "Télécharger les bordereaux"
      else if(documentType == "commission")
        buttonText = "Télécharger le Bulletin"
      else if(documentType == "decharge")
        buttonText = "Télécharger le Décharge"
      else if(documentType == "dt")
        buttonText = "Télécharger le Désistement/Transfert"
      else
        buttonText = "Télécharger"
    }
  }

  const handlePdf = async (data, func, downloadH, printH/*, actionAfterPrint*/) => {
    // if(spinner || true){
    setDisablePdf(true);
    if(!data && func){
      data = await func();
      setDisablePdf(false);
    }
    else
      setTimeout(() => setDisablePdf(false), 1000 + Math.random() * 500);
    
    if((documentType == "vente" || documentType == "part") && !data?.hasPermission)
      alert.info("Vous n'êtes pas autorisé à accéder à cette vente.")
    else{
      const pdfInfo = await generatePdfInfo(data, documentType, title, fileName, fileObject, fontSizeFactor, delaiMois, showPreviewWatermark, print);
      const asPdf = pdf(pdfInfo.doc);
      asPdf.updateContainer(pdfInfo.doc);
      const blob = await asPdf.toBlob();
      const urlFromBlob = URL.createObjectURL(blob);
      if(downloadH){
        saveAs(blob, fileName + '.pdf')
        if(actionAfterPrint)
          actionAfterPrint()
      }
      else if(printH){
        printJS(urlFromBlob)
        if(actionAfterPrint)
          actionAfterPrint()
      }
      else
        setPreviewUrl(urlFromBlob)
    }
  }

  return ready ? (<>
    {/* <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.5.207/build/pdf.worker.min.js"> */}
      <button key={htmlKey !== undefined ? htmlKey : Math.random()}
        className={customClassNames ? customClassNames : `btn btn-${download ? 'danger' : print ? 'success' : 'info'} pdfDownloadBtn`}
        disabled={disabled}
        style={style}
        title={htmlTitle}
        onClick={async () => {
          if(!data && func){
            setDisablePdf(true);
            data = await func();
            setDisablePdf(false);
          }
          if(data){
            await handlePdf(data, undefined, download, print/*, actionAfterPrint*/)
          }
        }}
      ><FontAwesomeIcon icon={disabled ? faSpinner : customButtonIcon ? customButtonIcon : download ? faFileDownload : print ? faPrint : faBookOpen} className={disabled ? "spinner" : ""} style={{fontSize: iconSize || "larger"}} />{buttonContent ? buttonContent : <>{buttonText !== "" && <>&nbsp;&nbsp;</>} {buttonText}</>}</button>
      <PDFPreviewModal modal={modal} setModal={setModal} handleToggle={handleToggle} modalClosedHandle={() => {}} handlePdf={handlePdf} data={data} func={func} btnIsDisabled={disabled} allowPrint={allowPrintPreview} previewUrl={previewUrl}/* actionAfterPrint={actionAfterPrint}*/ largeModal={largeModal} />
      {/* </Worker> */}
      </>) : null
};

const generateQrCodeWithLogo = async (qrUrl) => {
  try {
    // Create a canvas
    const canvasSize = 500;
    const canvas = createCanvas(canvasSize, canvasSize); // Adjust size as needed

    // Generate the QR code with high error correction (H)
    await QRCode.toCanvas(canvas, qrUrl, {
      errorCorrectionLevel: 'H', // Use high error correction to allow for the logo
      width: canvasSize, // Adjust the size of the QR code
    });

    const ctx = canvas.getContext('2d');
    const logo = await loadImage(`/images/icon.png`);

    const logoSize = canvasSize * 0.28;
    const circleSize = canvasSize * 0.3;
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;

    // Clear a circular area in the center of the QR code where the logo will be placed
    ctx.beginPath();
    ctx.arc(centerX, centerY, circleSize / 2, 0, Math.PI * 2); // Create a circular path
    ctx.closePath();
    ctx.clip(); // Clip the area to prevent QR code drawing inside the circle
    ctx.clearRect(centerX - circleSize / 2, centerY - circleSize / 2, circleSize, circleSize); // Clear the QR code inside the circular area

    // Restore the default clipping area after clearing
    ctx.restore();

    // Draw the logo in the cleared circular space
    ctx.drawImage(logo, centerX - logoSize / 2, centerY - logoSize / 2, logoSize, logoSize);

    // Convert the logo area to black and white
    const imageData = ctx.getImageData(centerX - logoSize / 2, centerY - logoSize / 2, logoSize, logoSize);
    const data = imageData.data;

    // Loop through each pixel and convert to grayscale
    for (let i = 0; i < data.length; i += 4) {
      const r = data[i];     // Red
      const g = data[i + 1]; // Green
      const b = data[i + 2]; // Blue

      // Calculate the grayscale value
      const grayscale = r * 0.3 + g * 0.59 + b * 0.11;

      // Set the red, green, and blue channels to the grayscale value
      data[i] = data[i + 1] = data[i + 2] = grayscale;
    }

    // Put the black-and-white image data back on the canvas
    ctx.putImageData(imageData, centerX - logoSize / 2, centerY - logoSize / 2);

    // Return the QR code as a base64-encoded image
    return canvas.toDataURL('image/png');
  } catch (error) {
    console.error('Error generating QR code with logo:', error);
    return null;
  }
};

const generatePdfInfo = async (data, documentType, title, fileName, fileObject, fontSizeFactor, delaiMois, showPreviewWatermark, print) => {
  if(!title){
    if(documentType == "vente")
      title = "Vente " + (data.PROJET ? data.PROJET + " " : "") + data.NUM_DOSS + (data.DATE_RESERV ? " " + moment(data.DATE_RESERV).format('DD/MM/YYYY') : "")
    else if(documentType == "part")
      title = "Part " + (data.contrat?.PROJET ? data.contrat.PROJET + " " : "") + (data.contat?.NUM_DOSS || "-") + (data.contrat?.DATE_RESERV ? " " + moment(data.contrat.DATE_RESERV).format('DD/MM/YYYY') : "")
    else if(documentType == "recu")
      title = "Reçu "//TODO
    else if(documentType == "contrat")
      title = "Contrat "//TODO
    else if(documentType == "client")
      title = "Client "//TODO
    else if(documentType == "encaissements")
      title = "Liste Encaissements "//TODO
    else if(documentType == "bordereau")
      title = "Bordereaux"//TODO
    else if(documentType == "commission")
      title = "Bulletin commission"//TODO
    else if(documentType == "decharge")
      title = "Décharge"//TODO
    else if(documentType == "dt")
      title = "Désistement/Transfert"//TODO
  }
  if(!fileName){
    if(documentType == "vente")
      fileName = "vente_" + (data.id || "brouillon") + "_" + (data.PROJET ? data.PROJET.toLowerCase() : "-") + "_" + data.NUM_DOSS + "_" + (data.DATE_RESERV ? moment(data.DATE_RESERV).format('DD-MM-YY') : "-")
    else if(documentType == "part")
      fileName = "part_" + (data.id || "brouillon") + "_" + (data.contrat?.PROJET ? data.contrat.PROJET.toLowerCase() : "-") + "_" + (data.contrat?.NUM_DOSS || "-") + "_" + (data.contrat?.DATE_RESERV ? moment(data.contrat?.DATE_RESERV).format('DD-MM-YY') : "-")
    else if(documentType == "recu")
      fileName = "recu_" + (data.id || "brouillon")
    else if(documentType == "contrat")
      fileName = "contrat_" + (data.id || "brouillon")
    else if(documentType == "client")
      fileName = "client_" + (data.id || "brouillon")
    else if(documentType == "encaissements")
      fileName = "encaissements"
    else if(documentType == "bordereau")
      fileName = "bordereaux"
    else if(documentType == "commission")
      fileName = "bulletin_commission"
    else if(documentType == "decharge")
      fileName = "decharge"
    else if(documentType == "dt")
      fileName = "desistement_transfert"
  }
  if(!fileObject){
    if(documentType == "vente")
      fileObject = "Fiche de Vente"
    else if(documentType == "part")
      fileObject = "Fiche de Part"
    else if(documentType == "recu")
      fileObject = "Reçu"
    else if(documentType == "contrat")
      fileObject = "Contrat"
    else if(documentType == "client")
      fileObject = "Client"
    else if(documentType == "encaissements")
      fileObject = "Encaissements"
    else if(documentType == "bordereau")
      fileObject = "Bordereaux"
    else if(documentType == "commission")
      fileObject = "Bulletin Commission"
    else if(documentType == "decharge")
      fileObject = "Décharge"
    else if(documentType == "dt")
      fileObject = "Désistement/Transfert"
  }

  // const qrCodeDataURL = await generateQrCodeWithLogo("https://drive.google.com/file/d/1qgBuURqPyYduxJBDFuAVgY7g5NhGGggd/view");
  const qrCodeDataURL = !!data?.webViewLink && await generateQrCodeWithLogo(data.webViewLink);

  const doc = documentType == "vente" ? <VenteDocument data={{...data, qrCodeDataURL}} documentType={documentType} showPreviewWatermark={showPreviewWatermark} title={title} fileObject={fileObject} />
            : documentType == "part" ? <PartDocument data={data} documentType={documentType} showPreviewWatermark={showPreviewWatermark} title={title} fileObject={fileObject} />
            : documentType == "recu" ? <RecuDocument data={{...data, qrCodeDataURL}} documentType={documentType} showPreviewWatermark={showPreviewWatermark} title={title} fileObject={fileObject} />
            : documentType == "contrat" ? <ContratDocument data={data} documentType={documentType} showPreviewWatermark={showPreviewWatermark} title={title} fileObject={fileObject} fontSizeFactor={fontSizeFactor} delaiMois={delaiMois} />
            : documentType == "client" ? <ClientDocument data={data} documentType={documentType} showPreviewWatermark={showPreviewWatermark} title={title} fileObject={fileObject} />
            : documentType == "encaissements" ? <ListeEncaissementsDocument data={data} documentType={documentType} showPreviewWatermark={showPreviewWatermark} title={title} fileObject={fileObject} />
            : documentType == "bordereau" ? <BordereauDocument data={data} documentType={documentType} showPreviewWatermark={showPreviewWatermark} title={title} fileObject={fileObject} />
            : documentType == "commission" ? <CommissionDocument data={data} documentType={documentType} showPreviewWatermark={showPreviewWatermark} title={title} fileObject={fileObject} />
            : documentType == "decharge" ? <DechargeDocument data={data} documentType={documentType} showPreviewWatermark={showPreviewWatermark} title={title} fileObject={fileObject} />
            : documentType == "dt" ? <DTDocument data={data} documentType={documentType} showPreviewWatermark={showPreviewWatermark} title={title} fileObject={fileObject} />
            : <></>;

  return {title, fileName, fileObject, doc}
}

export default PDFLink;

export const instantPrint = async ({documentType, fileName, title, data, fileObject, buttonText, download = true, print = false, spinner = false, style = {}, showPreviewWatermark = false, fontSizeFactor = 9, delaiMois = 24, func}: IPdflink) => {
  const pdfInfo = await generatePdfInfo(data, documentType, title, fileName, fileObject, fontSizeFactor, delaiMois, showPreviewWatermark, print);
  const asPdf = pdf(pdfInfo.doc);
  asPdf.updateContainer(pdfInfo.doc);
  const blob = await asPdf.toBlob();
  const urlFromBlob = URL.createObjectURL(blob);
  printJS(urlFromBlob)
};

export const instantUploadToFTP = async ({documentType, fileName, title, data, fileObject, buttonText, download = true, print = false, spinner = false, style = {}, showPreviewWatermark = false, fontSizeFactor = 9, delaiMois = 24, func}: IPdflink) => {
  const pdfInfo = await generatePdfInfo(data, documentType, title, fileName, fileObject, fontSizeFactor, delaiMois, showPreviewWatermark, print);
  const asPdf = pdf(pdfInfo.doc);
  asPdf.updateContainer(pdfInfo.doc);
  const blob = await asPdf.toBlob();

  const setCodedBuffer = async blob => {
    return new Promise<string>((resolve, reject) => {
      var reader = new FileReader();
      reader.onload = function() {
        var arrayBuffer = this.result,
          codedBuffer: string = "";
        (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
            codedBuffer += String.fromCharCode(byte);
        });
        console.log("arrayBuffer", arrayBuffer)
        // console.log("codedBuffer", codedBuffer)
        resolve(codedBuffer);
      };
      reader.readAsArrayBuffer(blob);
    });
  }

  const setCodedBuffer0 = (blob, name) => {
    var reader = new FileReader();
    reader.onload = function() {
      var arrayBuffer = this.result,
        codedBuffer: string = "";
      (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
          codedBuffer += String.fromCharCode(byte);
      });
      console.log("arrayBuffer", arrayBuffer)
      // console.log("codedBuffer", codedBuffer)
      uploadToFTP({codedBuffer, name}).then(e => console.log("success upload", e));
    }
    reader.readAsArrayBuffer(blob);
  };

  return await setCodedBuffer(blob/*, "testtest550"*/);
};

export const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays: any[] = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  console.log("blob", blob)
  return blob;
}

export const printBase64 = base64 => {
  const blob = b64toBlob(base64, 'application/pdf');
  const urlFromBlob = URL.createObjectURL(blob);
  printJS(urlFromBlob)
}

export const printBuffer = buffer => {
  const blob = new Blob([new Uint8Array(buffer).buffer])
  const urlFromBlob = URL.createObjectURL(blob);
  printJS(urlFromBlob)
};

export const downloadBase64 = (base64, fileName = 'download_todo.pdf') => {
  const blob = b64toBlob(base64, 'application/pdf');
  saveAs(blob, fileName)
}

export const PreviewBase64 = ({ base64, fileName = 'download_todo.pdf', modal = false, setModal = (e) => {}, actionAfterPrint = undefined }
  : { base64: string, fileName?: string, modal?: boolean, setModal?: (e: boolean) => void, actionAfterPrint?: () => void }) => {
  const [ready, setReady] = useState(false);
  const [disabled, setDisablePdf] = useState(false);
  // const [modal, setModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');

  const handleToggle = () => setModal(!modal);

  const modalClosedHandle = () => {
    // setPreviewUrl('');
  };

  useEffect(() => {
    setReady(false);
    setReady(true);
    return () => setReady(false);
    // setTimeout(() => {
    //   setReady(true);
    // }, 0);
  }, []);

  useEffect(() => {
    if(base64 !== '')
      handlePdf(base64, undefined, false, false/*, actionAfterPrint*/)
    else
      setPreviewUrl('')
  }, [base64]);

  // useEffect(() => {
  //   if(previewUrl !== '')
  //     setModal(true)
  // }, [previewUrl]);

  const handlePdf = (base64, func, downloadH, printH/*, actionAfterPrint*/) => {
    setDisablePdf(true);
    setTimeout(() => setDisablePdf(false), 1000 + Math.random() * 500);
    const blob = b64toBlob(base64, 'application/pdf');
    const urlFromBlob = URL.createObjectURL(blob);
    if(downloadH){
      saveAs(blob, fileName)//TODO filename
      if(actionAfterPrint)
        actionAfterPrint()
    }
    else if(printH){
      printJS(urlFromBlob)
      if(actionAfterPrint)
        actionAfterPrint()
    }
    else
      setPreviewUrl(urlFromBlob)
  }

  return ready ? <PDFPreviewModal modal={modal} setModal={setModal} handleToggle={handleToggle} modalClosedHandle={modalClosedHandle} handlePdf={handlePdf} data={base64} func={undefined} btnIsDisabled={disabled} allowPrint={true} previewUrl={previewUrl}/* actionAfterPrint={actionAfterPrint}*/ /> : null
}

export const InstantPreview = ({documentType, fileName, title, data, fileObject, buttonText, download = true, print = false, spinner = false, style = {}, showPreviewWatermark = false, fontSizeFactor = 9, delaiMois = 24, func, modal = false, setModal = (e) => {}, actionAfterPrint = null}: any) => {
  const [ready, setReady] = useState(false);
  const [disabled, setDisablePdf] = useState(false);
  // const [modal, setModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');

  const handleToggle = () => setModal(!modal);

  useEffect(() => {
    setReady(false);
    setReady(true);
    return () => setReady(false);
  }, []);

  useEffect(() => {
    if(!!data)
      handlePdf(data, undefined, false, false)
    else
      setPreviewUrl('')
  }, [data]);

  // useEffect(() => {
  //   if(previewUrl !== '')
  //     setModal(true)
  // }, [previewUrl]);

  const handlePdf = async (data, func, downloadH, printH) => {
    setDisablePdf(true);
    if(!data && func){
      data = await func();
      setDisablePdf(false);
    }
    else
      setTimeout(() => setDisablePdf(false), 1000 + Math.random() * 500);
    
    const pdfInfo = await generatePdfInfo(data, documentType, title, fileName, fileObject, fontSizeFactor, delaiMois, showPreviewWatermark, print);
    const asPdf = pdf(pdfInfo.doc);
    asPdf.updateContainer(pdfInfo.doc);
    const blob = await asPdf.toBlob();
    const urlFromBlob = URL.createObjectURL(blob);

    if(downloadH){
      saveAs(blob, fileName)//TODO filename
      if(actionAfterPrint)
        actionAfterPrint()
    }
    else if(printH){
      printJS(urlFromBlob)
      if(actionAfterPrint)
        actionAfterPrint()
    }
    else
      setPreviewUrl(urlFromBlob)
  }

  return ready ? <PDFPreviewModal modal={modal} setModal={setModal} modalClosedHandle={() => {}} handleToggle={handleToggle} handlePdf={handlePdf} data={data} func={func} btnIsDisabled={disabled} allowPrint={true} previewUrl={previewUrl}/* actionAfterPrint={actionAfterPrint}*/ /> : null
};